import { CFTokens } from '../../../../tokens';
export const BOX_FILL = {
    ALTERNATE: {
        DISABLED: {
            OFF: CFTokens.COLOR.INTERACTIVE_ALTERNATE_DISABLED,
            ON: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
        },
        ENABLED: {
            OFF: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
            ON: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
        },
    },
    DEFAULT: {
        DISABLED: {
            OFF: CFTokens.COLOR.INTERACTIVE_DISABLED,
            ON: CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        },
        ENABLED: {
            OFF: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
            ON: CFTokens.COLOR.TEXT_AND_ELEMENT_BRAND,
        },
    },
};
export const BOX_STROKE = {
    ALTERNATE: {
        DISABLED: {
            OFF: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
            ON: CFTokens.COLOR.TRANSPARENT,
        },
        ENABLED: {
            OFF: CFTokens.COLOR.TRANSPARENT,
            ON: CFTokens.COLOR.TRANSPARENT,
        },
    },
    DEFAULT: {
        DISABLED: {
            OFF: CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
            ON: CFTokens.COLOR.TRANSPARENT,
        },
        ENABLED: {
            OFF: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
            ON: CFTokens.COLOR.TRANSPARENT,
        },
    },
};
export const CHECK_FILL = {
    ALTERNATE: {
        DISABLED: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        ENABLED: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
    },
    DEFAULT: {
        DISABLED: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
        ENABLED: CFTokens.COLOR.TEXT_AND_ELEMENT_BOOST,
    },
};
export const CHECK_OPACITY = {
    OFF: 0,
    ON: 1,
};
export const CONTAINER_HEIGHT = 24;
export const CONTAINER_WIDTH = 24;
